var _a = require("@bilibili/js-bridge"), biliBridge = _a.biliBridge, initEnv = _a.initEnv;
import snsLogin from "./snsLogin";
import { openQuickLogin } from './getLogin';
import { isApp, isUat, isMobile } from "./detector";
if (isApp) {
    initEnv();
}
biliBridge.callNative({
    method: "global.import",
    data: {
        namespace: "auth",
    },
});
var defaultOption = {};
export default function jumpLogin(_a) {
    var _b = (_a === void 0 ? defaultOption : _a).snsLoginOption, snsLoginOption = _b === void 0 ? defaultOption.snsLoginOption : _b;
    return new Promise(function (resolve, reject) {
        if (!isMobile) {
            openQuickLogin();
            return;
        }
        if (!isApp && snsLoginOption) {
            snsLogin(snsLoginOption).then(function () {
                resolve();
            }, function (reason) {
                reject(reason);
            });
            return;
        }
        if (isApp && window.biliapp) {
            biliBridge.callNative({
                method: "auth.login",
                data: {
                    type: "default",
                },
                onLogin: function (data) {
                    console.log("onLoginCallback", data);
                    if (data) {
                        if (data.state === 0) {
                            reject({
                                reason: "cancel",
                            });
                        }
                        else {
                            resolve(data);
                        }
                    }
                    else {
                        reject();
                    }
                },
                callback: function () {
                    console.log("调起登陆窗口");
                },
            });
        }
        else {
            location.href = "https://" + (isUat ? "uat-" : "") + "passport.bilibili.com/login";
        }
    });
}
//# sourceMappingURL=jumpLogin.js.map